import React from 'react';
import { Popup } from 'antd-mobile';

/**
 * iOS16 系统升级提示弹窗
 *
 * Props:
 *   visible   {boolean}  是否显示
 *   onConfirm {Function} 点击"我知道了"回调
 */
export default function SystemUpgradeNotice({ visible, onConfirm }) {
  return (
    <Popup
      visible={visible}
      position="bottom"
      maskStyle={{ background: 'rgba(0,0,0,0.5)' }}
      bodyStyle={{
        background: 'transparent',
        boxShadow: 'none',
        // maxHeight: '100vh',
        // overflowY: 'auto',
      }}
    >
      {/* system-upgrade-notice 仅作为 CSS 选择器锚点，覆盖其 position:fixed 等布局属性 */}
      <div
        className="system-upgrade-notice"
        style={{ position: 'static', zIndex: 'auto', top: 'auto', left: 'auto', right: 'auto', bottom: 'auto' }}
      >
        <div className="upgrade-container">
          <img src="/resources/game/system-up-tips.png" alt="" />
          <div className="upgrade-main">
            <div className="upgrade-top">
              因您的系统升级为iOS16，现按照iOS官方要求，需开启开发者模式才可进入游戏
            </div>
            <div className="tips">开启流程如下</div>
            <img src="/resources/game/system-up-main.png" alt="" />
            <div className="upgrade-bottom-download" onClick={onConfirm}>
              我知道了
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
}
